const mSchoolColors = {
  physical: '#c79c6e',
  arcane: '#69ccf0',
  nature: '#abd473',
  holy: '#ffcc00',
  fire: '#c41f3b',
  frost: '#0070de',
  shadow: '#9482c9',
  elemental: '#00ff96',
  chaos: '#00c800',
  pet: '#64bdc8',
  chromatic: '#a330c9',
};
mSchoolColors.flamestrike = [mSchoolColors.fire, mSchoolColors.physical];
mSchoolColors.froststrike = [mSchoolColors.frost, mSchoolColors.physical];
mSchoolColors.spellstrike = [mSchoolColors.arcane, mSchoolColors.physical];
mSchoolColors.stormstrike = [mSchoolColors.nature, mSchoolColors.physical];
mSchoolColors.shadowstrike = [mSchoolColors.shadow, mSchoolColors.physical];
mSchoolColors.holystrike = [mSchoolColors.holy, mSchoolColors.physical];

mSchoolColors.frostfire = [mSchoolColors.frost, mSchoolColors.fire];
mSchoolColors.spellfire = [mSchoolColors.arcane, mSchoolColors.fire];
mSchoolColors.firestorm = [mSchoolColors.fire, mSchoolColors.nature];
mSchoolColors.shadowflame = [mSchoolColors.shadow, mSchoolColors.fire];
mSchoolColors.holyfire = [mSchoolColors.holy, mSchoolColors.fire];
mSchoolColors.spellfrost = [mSchoolColors.arcane, mSchoolColors.frost];
mSchoolColors.froststorm = [mSchoolColors.frost, mSchoolColors.nature];
mSchoolColors.shadowfrost = [mSchoolColors.shadow, mSchoolColors.frost];
mSchoolColors.holyfrost = [mSchoolColors.holy, mSchoolColors.frost];
mSchoolColors.astral = [mSchoolColors.arcane, mSchoolColors.nature];
mSchoolColors.spellshadow = [mSchoolColors.arcane, mSchoolColors.shadow];
mSchoolColors.divine = [mSchoolColors.arcane, mSchoolColors.holy];
mSchoolColors.shadowstorm = [mSchoolColors.shadow, mSchoolColors.nature];
mSchoolColors.holystorm = [mSchoolColors.holy, mSchoolColors.nature];
mSchoolColors.shadowlight = [mSchoolColors.shadow, mSchoolColors.holy];

export const schoolColors = mSchoolColors;
